import axiosInst from "api/config/axiosConfig";
import { showError } from "utils/notifications";

export const getDeviceBySerial = async (data: string) => {
  const response = await axiosInst.get(`/beta/appSystemInfo?snlookup=${data}`);
  if (!response.data) {
    showError("Incorrect Serial Number");
    throw new Error("Incorrect Serial Number");
  }
  return response.data;
};

export const getDeviceByImei = async (data: string) => {
  const response = await axiosInst.get(`/beta/appSystemInfo?imeilookup=${data}`);
  if (!response.data) {
    showError("Incorrect IMEI Number");
    throw new Error("Incorrect IMEI Number");
  }
  return response.data;
};
